export default __webpack_public_path__ + "static/media/signUpDemoIcon.fb3e3f3b.svg";